import { format } from "date-fns";

export function pdfService(paymentData) {
  let boleto_base64 = paymentData[0].boleto_base64;
  let cobranca_data_vencimento = paymentData[0].cobranca_data_vencimento;

  try {
    const isZoopPayment = !!paymentData[0].base64;

    if (isZoopPayment) {
      const [{ base64, payment_method }] = paymentData;

      boleto_base64 = base64;
      cobranca_data_vencimento = payment_method.expiration_date;
    }

    function showFile(blob) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob = new Blob([blob], { type: "application/pdf" });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement("a");
      link.href = data;
      link.target = "_blank"
      link.rel = "noopener noreferrer"
      link.download = `boleto-vencimento:${format(
        new Date(cobranca_data_vencimento),
        "dd/MM/yyyy"
      )}.pdf`;
      link.click();
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    }

    function decodeBase64(base64) {
      const binary = atob(base64.replace(/\s/g, ""));
      const len = binary.length;
      const buffer = new ArrayBuffer(len);

      let view = new Uint8Array(buffer);

      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }

      return view;
    }

    showFile(decodeBase64(boleto_base64));
  } catch (error) {
    console.error(error);
  }
}
